import { Stack } from '@moda/om';
import React from 'react';
import { ReturnPolicy } from '../../../generated/types/globalTypes';
import { LineItemReturnPolicyHeader } from '../../ReturnPolicyInformation';
import { LineItemReturnPolicyText } from '../../ReturnPolicyInformation';

interface Props {
  returnPolicy: ReturnPolicy | undefined;
  promoCodeApplied: boolean;
}

export const LineItemReturnPolicy: React.FC<Props> = ({ returnPolicy, promoCodeApplied }) => {
  if (!returnPolicy) return null;

  return (
    <Stack space={2}>
      <LineItemReturnPolicyHeader returnPolicy={returnPolicy} promoCodeApplied={promoCodeApplied} />

      <LineItemReturnPolicyText returnPolicy={returnPolicy} promoCodeApplied={promoCodeApplied} />
    </Stack>
  );
};
